import { ContainerCollection } from "./styles";
import icon8 from '../../../assets/Img/anima8.jpg';



export function Collection() {
    return(
        <ContainerCollection>
            <section>
                <div>
                    <img src={icon8} alt="Astro Phoenix" />
                    <p>Astro Phoenix</p>
                </div>
            </section>
            <div className="button">
                <a href="https://bit.ly/3wwMnOc" target="_blank" rel="noreferrer"> 
                    GET DRESSED
                </a>
            </div>
            <div className="texts">
                <p>Stay tuned for our Season 2 collection</p>
                <p>SPACE SPECTRES</p>
            </div>
        </ContainerCollection>
    )
}